import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as firebase from 'firebase';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  user = {
    email: "",
    password: ""
  }

  constructor(private router: Router) { }

  ngOnInit() {
    if (localStorage.getItem("uid")) {
      this.router.navigate([`dashboard`]);
    }
  }

  login() {
    if (!this.user.email) {
      return alert("Please enter email!");
    } else if (!this.user.password) {
      return alert("Please enter password!");
    }

    firebase.auth().signInWithEmailAndPassword(this.user.email, this.user.password)
      .then(user => {
        this.checkAdmin(user.user.uid);
      })
      .catch(err => {
        alert(err.message);
      })

    /* if (this.user.email === "admin@email.com" && this.user.password === "112233") {
      this.router.navigate([`dashboard`]);
    } else {
      alert("Invalid email/password!");
    } */
  }

  async checkAdmin(uid: string) {
    var snapshot = await firebase.database().ref("admin").once("value");

    if (snapshot.val() === uid) {
      localStorage.setItem("uid", uid);
      this.router.navigate([`dashboard`]);
    } else {
      firebase.auth().signOut();
      alert("Invalid email/password!");
    }
  }

}
